module.exports = __webpack_public_path__ + "img/interlocution.037a1608.jpg";